<template>
    <div class="t_search_box">
        <img style="width:14px" src="../../assets/img/search.png">
        <el-input class="t_search_input" style="flex: 1;" v-model="searchinput" placeholder="请输入成员姓名/部门"  clearable />
    </div>
    <div class="t_tree_comp">
        <img style="width:14px;margin-right: 5px;" src="../../assets/img/treecomp.png" />
        {{logincompname}}
    </div>
    <!-- 搜索出的成员 -->
    <div v-if="issearch" class="t_search_res_title">成员</div>
    <div v-if="issearch"  style="margin-bottom:15px" >
        <div class="t_search_peo" v-for="(item,index) in searchpeolist.data" :key="index">
            <div>{{item.name}}</div>
            <el-button size="small" type="text" style="color:#4F46E5"
            @click="peoinfo(item)">成员详情</el-button>
        </div>
    </div>
    <div v-if="issearch"  class="t_search_res_title">部门</div>
    <div class="t_tree_box">
        <el-tree :data="Tree.treedata" ref="treeForm"  
     @node-click="handleNodeClick" :filter-node-method="filterNode" />
    </div>
    
    <div class="t_tb_box">
        <div @click="nowgetbmtree" class="t_tb_btn">
            <img src="../../assets/img/tbbm.png" alt="">
            同步部门
        </div>
        <div @click="nowgetusers" class="t_tb_btn">
            <img src="../../assets/img/tbcy.png" alt="">
            同步成员
        </div>
    </div>
    <!-- 成员详情 -->
    <el-dialog
        v-model="infoshow"
        title="成员详情"
        width="800px"
    >
        <el-descriptions direction="vertical"
        border >
        <el-descriptions-item label="创建人">{{peoinfodata.data.createBy}}</el-descriptions-item>
        <el-descriptions-item label="开通群聊数">{{peoinfodata.data.createGroupNum}}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{peoinfodata.data.createTime}}</el-descriptions-item>
        <el-descriptions-item label="性别">
            <span v-if='peoinfodata.data.gender==1'>男</span><span v-else-if='peoinfodata.data.gender==2'>女</span><span v-else-if='peoinfodata.data.gender==0'>未定义</span>
        </el-descriptions-item>
        <el-descriptions-item label="群聊数"
        >{{peoinfodata.data.groupNum}}</el-descriptions-item>
        <el-descriptions-item label="openid"
        >{{peoinfodata.data.openUserid}}</el-descriptions-item>
        <el-descriptions-item label="员工个人二维码"
        >{{peoinfodata.data.qrCode}}</el-descriptions-item>
        <el-descriptions-item label="修改人"
        >{{peoinfodata.data.updateBy}}</el-descriptions-item>
        <el-descriptions-item label="修改时间"
        >{{peoinfodata.data.updateTime}}</el-descriptions-item>
    </el-descriptions>
    </el-dialog>
</template>
<script setup>
import { ref, reactive,  provide, onBeforeMount, onMounted,watch,inject } from 'vue'
// import { department,nowdepartment,nowusers,peolist } from '@/assets/js/common.js' // work/bcDepartment* 老接口已废弃
import { ElMessage } from 'element-plus'
import { useStore } from '../../store'
import { storeToRefs } from 'pinia'
const store = useStore();
const { tree_corpId,tree_departId,tbuser } = storeToRefs(store)
//动态获取接口地址
const _url2 = inject('_url2')

//公司名称
const logincompname = ref('')
onMounted(() => {
    console.log('onMounted')
    //同步部门列表
    nowgetbmtree()
    logincompname.value=$cookies.get("fanscorpname")

})

//同步部门列表
const nowgetbmtree = ()=>{ 
  // work/bcDepartment 老接口已废弃
  // nowdepartment(_url2,{
  //   corp_id:$cookies.get("fanscorpId")
  // }).then((response) => {
  //       // console.log(response)
  //       if(response.data.msg.code==0){
  //          getbmtree()
  //          searchinput.value=''
  //       }
  //   })
}
//同步成员
const nowgetusers = ()=>{ 
  // work/bcDepartment 老接口已废弃
  // nowusers(_url2,{
  //   corp_id:$cookies.get("fanscorpId")
  // }).then((response) => {
  //       
  //       if(response.data.msg.code==0){
  //         tbuser.value++
  //       }
  //       console.log(tbuser)
  //   })
}
//tree数据
const Tree = reactive({
  treedata:[]
})
//获取部门列表
const getbmtree = ()=>{
  // work/bcDepartment 老接口已废弃
  // department(_url2,{
  //   corp_id:$cookies.get("fanscorpId")
  // }).then((response) => {
  //   //   console.log(response)
  //       if(response.data.msg.code==0){
  //         Tree.treedata = response.data.result
  //       }
  //   })
}
//当前选择的树

const handleNodeClick = (data)=>{
    // console.log(data)
    // console.log(data.id)
    // console.log(Tree.treedata[0])
    //判断当前点击的是否是根节点
    if(data.id==Tree.treedata[0].id){
        tree_corpId.value=''
        tree_departId.value=''
    }else{
        tree_corpId.value=data.corpId
        tree_departId.value=data.departId
    }
    
}


//搜索内容
const searchinput = ref('')
const treeForm = ref('')
//树筛选
const filterNode = (value,data)=>{
    return data.label.includes(value)
}
//筛选出的成员
const searchpeolist = reactive({
    data:[]
})
// 成员详情弹窗
const infoshow = ref(false)
//当前成员详情数据
const peoinfodata = reactive({
    data:{}
})
//打开成员详情弹窗
const peoinfo = (row)=>{
    infoshow.value=true
    peoinfodata.data=row
}
//是否进行了搜索
const issearch = ref(false)
//单个监听,监听筛选树
watch(searchinput, (val) => {
    // 过滤操作
    treeForm.value.filter(val)
    console.log(val)
    if(val!=''){
        issearch.value=true
        //筛选所有人员
        // work/bcDepartment 老接口已废弃
        // peolist(_url2,{
        //     //当前页
        //     pageNo:1,
        //     corpId:$cookies.get("fanscorpId"),
        //     departmentId:'',
        //     name:val,
        //     pageSize:20000000
        // }).then((response) => {
        //     if (response.data.msg.code == 0) {
        //         console.log('筛选人员')
        //         console.log(response.data.result.records)
        //         searchpeolist.data = response.data.result.records
        //     }
        // })
    }else{
        searchpeolist.data=[]
        issearch.value=false
    }
    
})

</script>
<style scoped>
.t_search_box{
    border: 1px solid #4F46E5;
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding:0 15px;
    margin-bottom: 20px;
}
:deep(.t_search_input .el-input__wrapper){
    box-shadow: 0 0 0 0 black;
}
.t_tree_comp{
    display: flex;
    padding: 10px 15px;
    align-items: center;
    background-color: #F1F3F9;
    border-radius: 5px;
    font-size: 15px;
    margin-bottom: 20px;
}
.t_tb_box{
    display: flex;
    justify-content: space-between;
}
.t_tb_btn{
    border: 1px solid #E3E3E3;
    border-radius: 3px;
    text-align: center;
    line-height: 34px;
    font-size: 14px;
    color: #333333;
    padding: 0 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.t_tb_btn img{
 height: 14px;
 margin-right: 5px;
}
.t_tree_box{
    height: calc(100% - 180px);
    overflow: auto;
    margin-bottom: 15px;
}
.t_search_peo{
    display: flex;
    justify-content: space-between;
    font-size: 15px;
}
.t_search_res_title{
    background-color: #f5f6f7;
    color:#646a73;
    font-size: 15px;
    padding: 10px;
    margin-bottom: 10px;
}
</style>